"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = void 0;
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const Monitor_1 = require("./Monitor");
const VizzlyApiClientLogger_1 = require("./VizzlyApiClientLogger");
const Path_1 = require("./Path");
class Api {
    constructor(auth, host, extraHeaders = () => ({})) {
        this.host = host;
        this.extraHeaders = extraHeaders;
        this.auth = auth;
    }
    execute(request) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const authHeaders = this.auth.buildAuthHeaders(request.acceptedAuthParams);
            const customHeaders = Object.assign(Object.assign({}, (request.headers || {})), (this.extraHeaders() || {}));
            const path = Path_1.Path.buildPath(this.host, request.path);
            const timedFetch = Monitor_1.Monitor.timeRequest(request.method, path, cross_fetch_1.default);
            const res = yield timedFetch(path, {
                method: request.method,
                headers: Object.assign(Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json', 'Vizzly-User-Agent': `${VizzlyApiClientLogger_1.VizzlyApiClientLogger.UserAgentProduct}${this.originApp()} (Using client ${(_a = require('../../package.json')) === null || _a === void 0 ? void 0 : _a.version})` }, authHeaders), customHeaders),
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: request.body ? JSON.stringify(request.body) : null,
                signal: request.abortSignal,
            });
            let body = ((_b = res.headers.get('content-type')) === null || _b === void 0 ? void 0 : _b.includes('json')) ? yield res.json() : res.text();
            const queryEngineRequestId = res.headers.get('vizzly-query-engine-request-id') || '-';
            const vizzlyApiRequestId = res.headers.get('x-request-id') || '-';
            if (res.status === 500) {
                VizzlyApiClientLogger_1.VizzlyApiClientLogger.debug(`[TRACING] QE; ${queryEngineRequestId} - API; ${vizzlyApiRequestId}`);
            }
            VizzlyApiClientLogger_1.VizzlyApiClientLogger.debug(`[TRACING] QE; ${queryEngineRequestId} - API; ${vizzlyApiRequestId}`);
            return { body: body, status: res.status, headers: res.headers };
        });
    }
    originApp() {
        const isServer = !(typeof window != 'undefined' && window.document);
        if (isServer) {
            const testApp = process.env['NODE_ENV'] === 'test' ? 'tests' : '';
            const origin = process.env['VIZZLY_ORIGIN_APP'] || testApp || '';
            if (origin == '')
                return '';
            return ` (${origin})`;
        }
        return '';
    }
    getAuth() {
        return this.auth;
    }
}
exports.Api = Api;
